import Vue from "vue";
import Slideshow from "./installation-image-slideshow.vue";
import * as focusTrap from "focus-trap";

window.addEventListener("DOMContentLoaded", () => {
  const images = document.querySelectorAll("[data-installation-image]");
  const url = new URL(window.location.href);
  const index = url.searchParams.get("installation_image_index");
  let parsedIndex = Number.parseInt(index, 10);

  images.forEach((el) => {
    el.addEventListener("click", (e) => { slideshowClickHandler(e); });
  });

  if (Number.isInteger(parsedIndex) && parsedIndex >= 0) {
    let el = document.querySelector(`[data-installation-image-index="${parsedIndex}"]`);
    el.click();
  }
});

function getMetaImageURL() {
  return document.head.querySelector("[property~='og:image'][content]").content;
}

function slideshowClickHandler(e) {
  e.preventDefault();
  const originElement = e.currentTarget;
  const overlayNode = document.querySelector("[data-overlay-vue-container]");
  const objectId = parseInt(e.currentTarget.getAttribute('data-object-id'));
  const index = parseInt(e.currentTarget.getAttribute('data-installation-image-index'));
  let shouldOpen = true;
  let originalMetaImageURL = getMetaImageURL();
  let installationSource = "collection/works";
  let iiType = document.querySelector("[data-current-primary-nav-item]");
  if (iiType.getAttribute('data-current-primary-nav-item') == "exhibitions") {
    installationSource = "calendar/exhibitions";
  }

  const template = `
    <Slideshow
      :objectId=objectId
      :index=index
      :installationSource=installationSource
      :originElement=originElement
      v-if="open"
      @close="close()"
      @setMetaImage="setMetaImage"
      >
    </Slideshow>
    <div
      v-else
      data-overlay-vue-container>
    </div>
  `;

  new Vue({
    el: overlayNode,
    components: { Slideshow },

    data: {
      objectId: objectId,
      index: index,
      open: shouldOpen,
      originalMetaImageURL: originalMetaImageURL,
      installationSource: installationSource,
      originElement: originElement,
      focusTrapInstance: null
    },

    mounted() {
      const overlayVueContainer = document.getElementById("installation-overlay");
      this.focusTrapInstance = focusTrap.createFocusTrap(overlayVueContainer, {
        setReturnFocus: this.originElement
      });
      this.focusTrapInstance.activate();
    },

    methods: {
      close() {
        this.open = false;
        window.MoMA.ScrollManager.enableScroll();
        const params = new URLSearchParams(location.search);
        params.delete("installation_image_index");
        this.setMetaImage(this.originalMetaImageURL);
        this.focusTrapInstance.deactivate();
        window.history.replaceState({}, "", `${location.pathname}?${params}`);
      },

      setMetaImage(imageUrl) {
        document.querySelector("[property='og:image']").setAttribute("content", imageUrl);
      },
    },
    template: template
  });
}
